<template>
  <div>
    <div class="journalismContainer" v-if="list.length">
      <div class="journalism">
        <ul>
          <li v-for="(item, index) in list" :key="index">
            <div class="imgBox">
              <img :src="item.titlepic" alt="" />
            </div>
            <div class="Date">
              <div class="month">{{ item.makedate.substring(5) }}</div>
              <div class="year">{{ item.makedate.substring(0, 4) }}</div>
            </div>
            <div class="content">
              <div class="title" @click="detailsPage(item.id)">
                {{ item.mtitle }}
              </div>
              <div class="details" v-html="item.fcontents"></div>
            </div>
            <div class="moreBox" @click="detailsPage(item.id)">
              <div class="more">
                <i class="el-icon-arrow-down"></i>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="paginationBox">
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="index"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="pageSize"
            layout="prev, pager, next, jumper, sizes , total"
            :total="totalSize"
            prev-text="上一页"
            next-text="下一页"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div v-else>
      <el-empty description="暂未发布新闻"></el-empty>
    </div>
  </div>
</template>

<script>
import { getnewsinfo } from "@/api";
export default {
  data() {
    return {
      index: 1,
      pageSize: 5,
      totalSize: null,
      list: [],
      listAll: [],
    };
  },
  methods: {
    detailsPage(id) {
      this.$router.push({
        path: "/j_details",
        query: {
          id,
        },
      });
    },
    async getnewsinfoLiist() {
      let usercode = window.sessionStorage.getItem("usercode");
      let token = window.sessionStorage.getItem("token");
      const { data: res } = await getnewsinfo({
        usercode,
        token,
        id: "0",
      });
      this.listAll = JSON.parse(res);
      this.getList();
    },
    getList() {
      this.list = this.listAll.filter(
        (item, index) =>
          index < this.index * this.pageSize &&
          index >= this.pageSize * (this.index - 1)
      );
      this.totalSize = this.listAll.length;
    },
    /**
     * @name: 分页
     */
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.index = val;
      this.getList();
    },
  },
  mounted() {
    this.getnewsinfoLiist();
  },
};
</script>
<style lang='less' scoped>
.journalismContainer {
  margin-top: 10px;
  .paginationBox {
    .block {
      margin-top: 20px;
      float: right;
      width: 100%;
      text-align: center;
      margin-bottom: 180px;
    }
  }

  .journalism {
    width: 1000px;
    margin: 0 auto;
    .imgBox {
      img {
        width: 250px;
        height: 140px;
        object-fit: cover;
      }
    }
    ul {
      margin-top: 20px;
    }
    ul li {
      display: flex;
      justify-content: space-between;
      padding: 25px 0;
      border-bottom: 2px solid #cccccc;
      .moreBox {
        cursor: pointer;
        display: flex;
        align-items: center;
        .more {
          border: 1px solid #8f8f8f;
          border-radius: 50%;
          padding: 10px;
          display: flex;
          align-items: center;
          .el-icon-arrow-down {
            font-size: 16px;
          }
        }
      }
      .Date {
        padding-top: 20px;
        display: flex;
        flex-direction: column;
        .month {
          font-size: 18px;
          color: #989898;
        }
        .year {
          margin-top: 5px;
          color: #8d8d8d;
          font-size: 14px;
          font-style: oblique;
        }
      }
      .content {
        width: 50%;
        .title {
          cursor: pointer;
          color: #333333;
          font-size: 18px;
          font-weight: 500;
        }
        .title:hover {
          color: #c44f52;
        }
        .details {
          margin-top: 15px;
          color: #999999;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          font-size: 14px;
          line-height: 19px;
        }
      }
    }
  }
}
</style>